<template>
    <div
        class="text-asterisk text-dovegray"
        :data-component="$options.name"
    >
        Wie auf allen Online-Portalen kann es auch bei meinestadt.de in Einzelfällen passieren, dass gefälschte Anzeigen
        ausgespielt werden. Trotz umfangreicher Bemühungen lässt sich das leider nicht vollständig vermeiden. Lies hier
        unsere
        <cs-copy-text-link
            :href="safetyInstructionsUrl"
            :target="'_blank'"
            >Sicherheitshinweise zum Thema Immobilienbetrug</cs-copy-text-link
        >
        und erfahre, woran du solche Anzeigen erkennst, wie du dich vor Betrugsversuchen schützt und wie du dich im
        Betrugsfall verhältst. Bitte beachte, dass meinestadt.de und immowelt.de nicht für die Inhalte der Inserate
        verantwortlich sind und im Schadensfall nicht haften.
    </div>
</template>
<script lang="ts" src="./MsSafetyInstructions.ts" />
